The response from the `updateUploadedCandidateProfilePositionPreferences` mutation.
